import React from 'react';

export const Spinner = () =>
    <div className="spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div >;

export default Spinner;